import Layout from '@/layout/defaultOther';
import RouterView from '@@/compose/routerView.vue'
// 投票管理
const voteRouter = {
    path: '/operate_manage', 
    name: 'operate_manage',
    component: Layout,
    children: [
        {
            path: 'vote', 
            name: 'vote_management_index',
            meta: {title: '投票管理'},
            component: () => import('@/views/operate_manage/vote_management/index.vue')
        },
        {
            path: 'add_vote', // 新建投票
            name: 'add_vote',
            meta: {title: '新建投票'},
            component: () => import('@/views/operate_manage/vote_management/op_vote.vue')
        },
        {
            path: 'edit_vote', // 编辑投票
            name: 'edit_vote',
            meta: {title: '编辑投票'},
            component: () => import('@/views/operate_manage/vote_management/op_vote.vue')
        },
        {
            path: 'vote_analysis', // 查看投票数据
            name: 'vote_analysis',
            meta: {title: '查看投票数据'},
            component: () => import('@/views/operate_manage/vote_management/vote_analysis.vue')
        },
        {
            path: 'spread', // 推广更新
            name: 'spread',
            component: RouterView,
            children: [{
                path: '',
                name: 'spread-index',
                meta: {title: '推广更新'},
                component: () => import('@/views/operate_manage/spread/index.vue')
            },{
                path: 'add',
                name: 'spread-add',
                meta: {title: '创建推广计划'},
                component: () => import('@/views/operate_manage/spread/add.vue')
            }]
        },
        {
            path: 'drawtool', // 抽奖管理
            name: 'drawtool',
            children: [{
                path: '',
                name: 'drawtool_init',
                meta: {title: '抽奖管理'},
                component: () => import('@/views/operate_manage/draw_tools/list.vue')
            },{
                path: 'initiate',
                name: 'drawtool_initiate',
                meta: {title: '创建抽奖'},
                component: () => import('@/views/operate_manage/draw_tools/init.vue')
            },{
                path: 'create',
                name: 'drawtool_initiate_id',
                meta: {title: '创建抽奖'},
                component: () => import('@/views/operate_manage/draw_tools/create.vue')
            },
            {
                path: 'success',
                name: 'drawtool_initiate_success',
                meta: {title: '创建抽奖'},
                component: () => import('@/views/operate_manage/draw_tools/success.vue')
            },
            {
                path: 'sendraw',
                name: 'drawtool_initiate_sendraw',
                meta: {title: '发放奖品'},
                component: () => import('@/views/operate_manage/draw_tools/sendraw.vue')
            }]
        },
        {
            path: 'task', 
            name: 'task',
            meta: {title: '任务中心'},
            component: () => import('@/views/operate_manage/task/index.vue')
        },
        {
            path: 'gold', 
            name: 'gold',
            meta: {title: '金币推广服务'},
            component: () => import('@/views/operate_manage/gold/index.vue')
        },
        {
            path: 'miner', 
            name: 'miner',
            meta: {title: '矿工财富榜'},
            component: () => import('@/views/operate_manage/miner/index.vue')
        },
        {
            path: 'goals/:id', // 解锁目标
            name: '解锁目标',
            meta: {title: '解锁目标'},
            component: () => import('@/views/operate_manage/goals/_id.vue')
        },
        {
            path: 'goods/:id', // 商品管理
            name: '商品管理',
            meta: {title: '商品管理'},
            component: () => import('@/views/operate_manage/goods/_id.vue')
        },
    ]
};

export default voteRouter;
